import { Action, SubjectRoles } from "@/api-schema-enums";
import type { AppAbility } from "@/casl-provider";

export interface RelocationOrderDetailAccess {
  isInternalUser: boolean;
  canManage: boolean;
  canUpdate: boolean;
  showInternalFlowActions: boolean;
  showExternalFlowActions: boolean;
  overviewPath: string;
}

export function getRelocationOrderDetailAccess(
  roles: SubjectRoles[],
  ability: Pick<AppAbility, "can">,
): RelocationOrderDetailAccess {
  const isInternalUser = roles.includes(SubjectRoles.Int);
  const canManage = ability.can(Action.Manage, "RelocationOrder");

  return {
    isInternalUser,
    canManage,
    canUpdate: ability.can(Action.Update, "RelocationOrder"),
    showInternalFlowActions: isInternalUser,
    showExternalFlowActions: roles.includes(SubjectRoles.FitExtAdministrator),
    overviewPath: canManage ? "~/fit/relocation-order" : "~/fit/relocation-request",
  };
}
